import "./datetime.css";
import DateTimeDisplay from "./DateTimeDisplay";
import useCountDown from "./hooks/useCountDown";

const ExpiredNotice = () => {
  return (
    <div className="expired-notice">
      <span>Vaqt tugadi!!!</span>
      <p></p>
    </div>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="show-counter">
      <a
        rel="noopener noreferrer"
        className="countdown-link"
      >
        <DateTimeDisplay value={days} type={"Kun"} isDanger={days <= 3} />
        <p>:</p>
        <DateTimeDisplay value={hours} type={"Soat"} isDanger={false} />
        <p>:</p>
        <DateTimeDisplay value={minutes} type={"Minut"} isDanger={false} />
        <p>:</p>
        <DateTimeDisplay value={seconds} type={"Sekund"} isDanger={false} />
      </a>
    </div>
  );
};

const CountDownTimer = ({ targetDate }) => {
  const [days, hours, minutes, seconds] = useCountDown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice />;
  } else {
    return (
      <ShowCounter
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    );
  }
};

export default CountDownTimer;